import pageClose from "@/components/Closed.vue";
import pageIndex from "@/components/Index.vue";
import page404 from "@/components/Page404.vue";
import pagePromo from "@/components/Promo.vue";
import VueRouter from "vue-router";

// This is for tests
// const battlepass_path = "/minigames/battlepass";
// This is for prod
const battlepass_path = "/warface_seasons";

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: battlepass_path,
      components: {
        trial: pageIndex,
        member: pageIndex,
        guest: pagePromo,
        former: pagePromo,
        closed: pageClose,
      },
      alias: "/battlepass",
    },
    {
      path: "*",
      components: {
        trial: page404,
        member: page404,
        guest: page404,
        former: page404,
        closed: page404,
      },
    },
  ],
});

export default router;
